import React, { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'src/utils/store'
import { useFulfillmentCenter } from 'src/hooks/useFulfillmentCenter'
import { useDispatch } from 'react-redux'
import { useForm } from 'react-hook-form'
import { actions, initialState } from '../../../RestockingState'
import { capitalizeString } from 'src/utils/capitalize'
import { Typography, Box } from '@mui/material'
import { formatDateReplaceHour } from 'src/utils/formatDate'
import Page from 'src/features/restocking/components/RestockingWebAppForm/components/Page/Page'
import Content from 'src/features/restocking/components/RestockingWebAppForm/components/Content/Content'
import CardList from 'src/features/restocking/components/RestockingWebAppForm/components/CardList/CardList'
import MultipleSelect from 'src/components/MultipleSelect/MultipleSelect'
import * as S from './ListSelectionPage.styles'
import { isEqual } from 'lodash'

const ListSelectionPage: React.FC = () => {
  const [loading, setLoading] = useState(true)
  const {
    user, hasForkliftAuth, availableRestockLists, filtersSearchLists,
  } = useSelector((state) => state.restocking)
  const { fc, validateFc } = useFulfillmentCenter()
  const dispatch = useDispatch()

  const typesOptions = useMemo(() => filtersSearchLists.types.map((option) => ({
    id: option.id,
    description: capitalizeString(option.description),
  })), [filtersSearchLists.types])

  const {
    register, handleSubmit, formState: { errors },
  } = useForm<{idType: number[]}>({ defaultValues: { idType: typesOptions.map((o) => o.id) } })

  useEffect(() => {
    validateFc()
  }, [validateFc])

  useEffect(() => {
    const hasNotFiltersSearchLists = isEqual(filtersSearchLists, initialState.filtersSearchLists)
    if (hasNotFiltersSearchLists) {
      dispatch(actions.getFiltersSearchLists(true))
    }
  }, [dispatch, filtersSearchLists])

  const onSubmit = (formData) => {
    if (hasForkliftAuth !== undefined && formData.idType.length > 0 && fc) {
      dispatch(actions.getAvailableRestockLists({
        idFulfillmentCenter: fc.id,
        hasForkliftAuth,
        idType: formData.idType,
        badge: user.badge,
        setLoading,
      }))
    }
  }

  return (
    <Page
      headerTitle='Reposição'
      goBackRoute='/restocking/webapp/type-question'
      propertyToClear={['idRestockingType', 'availableRestockLists']}
    >
      <Box
        component='form'
        onSubmit={handleSubmit(onSubmit)}
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          flexDirection: 'column',
          gap: '.6rem',
          width: '100%',
          margin: '1.3rem 0 1.3rem 0',
          padding: '0 0.5rem',
        }}
      >
        <MultipleSelect
          required
          register={register}
          inputName='idType'
          label='Tipo'
          errors={errors.idType}
          options={typesOptions}
          dataTestId='idType-test-id'
          maxHeight='600px'
          optionProperty='id'
          fullWidth
          searchBar
          selectAll
          closeButton
        />
        <S.CustomButton
          title='Buscar'
          type='submit'
          bgColor='blue'
          hoverColor='darkBlueHover'
          letterColor='white'
          data-testid='search-lists-button'
        />
      </Box>
      {
        loading ? null
          : availableRestockLists.length > 0 ? (
            <Content text='Selecione a lista de reposição:'>
              {availableRestockLists.map((list) => {
                const {
                  id, priority, totalPages, pagesNotAvailable, createdAt, type, orderCode, destinationFc,
                } = list

                return (
                  <CardList
                    key={id}
                    badge={user.badge}
                    idList={id}
                    totalPages={totalPages}
                    pagesNotAvailable={pagesNotAvailable}
                    priority={priority}
                    createdAt={formatDateReplaceHour(createdAt)}
                    type={type}
                    orderCode={orderCode}
                    destinationFc={destinationFc}
                  />
                )
              })}
            </Content>
          ) : (
            <Typography pt={1}>Não há listas disponíveis</Typography>
          )
      }
    </Page>
  )
}

export default ListSelectionPage
